import { useState, useEffect } from 'react';
import { BannerProps } from './Banner';

export function useBannerData(bannerType: string): BannerProps | null {
    const [bannerData, setBannerData] = useState<BannerProps | null>(null);

    useEffect(() => {
        const vipDonor = window.isVIPDonor();
        const url = vipDonor ? `/banner.html?type=${bannerType}&topdonor=true` : `/banner.html?type=${bannerType}`;
        fetch(url)
            .then(res => res.ok ? res.json() : null)
            .then(data => data ? setBannerData(data) : null)
            .catch(error => console.error(error));
    }, [bannerType]);

    return bannerData;
}
